export const environment = {
  production: false,
  baseHref: '/',
  captchaKey: '6Lc8UdIZAAAAAIGlf8PNGfGxqJySWE1_7YUd_oW8',
};
